Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    Entities.Recipe = Entities.Model.extend();
});
